import { FC } from "react";
import { Typography } from "antd";

const FeatureUsageTab: FC = () => {
    return (
        <div>
            <Typography.Title level={4}>Feature Usage</Typography.Title>
            <Typography.Text>Analytics of feature adoption will be shown here.</Typography.Text>
        </div>
    );
};

export default FeatureUsageTab;
